
import {TEAM_APPLY_JOB_LIST2_REQUEST, TEAM_APPLY_JOB_LIST2_SUCCESS,TEAM_APPLY_JOB_LIST2_FAIL} from "../constants/AuthConstant"

const axios = require("axios");
export const TeamApplyJobListAction = (id) => {
    return function (dispatch) {
      dispatch({
        type: TEAM_APPLY_JOB_LIST2_REQUEST,
        payload: true,
      });
   
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/get_apply_job_list_by_vendorId?vendorId=${id}&pageNumber=0&pageSize=10`,
        method: "GET",
        headers: {
          "content-type": "application/json",
          // token: token, 
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: TEAM_APPLY_JOB_LIST2_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: TEAM_APPLY_JOB_LIST2_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };